<!-- eslint-disable @angular-eslint/template/i18n -->
<div class="footer-wrapper">
  <div class="desktop-logo-social-wrapper">
    <a
      rel="nofollow"
      href="http://www.foodtecsolutions.com"
      target="_blank"
      class="foodtec-link first"
      [attr.aria-label]="'footer.foodtec_logo_alt' | transloco"
    >
      <img
        [src]="configState().store?.foodtecLogo"
        [attr.alt]="'footer.foodtec_logo_alt' | transloco"
        class="foodtec-link-img"
      />
    </a>
    <cwo-social-links />
  </div>
  
  <div class="links-wrapper">
    @for (link of routerLinks; track $index; let first = $first) { 
        @if (!first) {
            <div class="separator"></div>
        } 
        @if (link.href) {
            <a
                [href]="link.href"
                target="_blank"
                [attr.aria-label]="('footer.opens_in_a_new_tab_aria' | transloco : {platform: link.name | async})"
                class="primary-text-color fw-300 footer-menu-link"
            >
            {{ link.name | async }}
            </a>
        } @else {
            <a
                [routerLink]="link.routerLink"
                [queryParams]="{ type: link.type }"
                class="primary-text-color fw-300 footer-menu-link"
            >
            {{ link.name | async }}
            </a>
        }
    }
    @if(footerFeaturedContentLinks.length) {
      @for (featuredContent of footerFeaturedContentLinks; track $index) {
        @for (featuredItem of featuredContent?.featuredItems ?? []; track $index; let first = $first) { 
          @if (!first) {
              <div class="separator"></div>
          } 
          @if (featuredItem?.link) {
              <a
                  [href]="featuredItem?.link"
                  target="_blank"
                  [attr.aria-label]="('footer.opens_in_a_new_tab_aria' | transloco : {platform: featuredItem?.title})"
                  class="primary-text-color fw-300 footer-menu-link"
              >
              {{ featuredItem?.title }}
              </a>
          }
      }
      }
    }
  </div>

  <a
      rel="nofollow"
      href="http://www.foodtecsolutions.com"
      target="_blank"
      class="foodtec-link last"
      [attr.aria-label]="'footer.foodtec_logo_alt' | transloco"
    >
      <img
        [src]="configState().store?.foodtecLogo"
        [attr.alt]="'footer.foodtec_logo_alt' | transloco"
        class="foodtec-link-img"
      />
    </a>
</div>
